import { DELETE, PATCH, POST } from "lib/core/api"
import { TEST_TYPES } from "lib/leeruniek/constants"

export const noteTypeMapping = {
  [TEST_TYPES.NATIONAL]: {
    url: "/cito_score_note",
    category: "cito_score",
    scoreIdKey: "citoTestScoreId",
    scoresStoreKey: "scores",
  },
  [TEST_TYPES.METHOD]: {
    url: "/method_score_note",
    category: "method_score",
    scoreIdKey: "methodTestScoreId",
    scoresStoreKey: "methodScores",
  },
}

export const createScoreNoteApi = ({
  content,
  forwardLooking,
  scoreId,
  testType,
}: {
  content: string
  forwardLooking: boolean
  scoreId: number
  testType: string
}) =>
  POST(noteTypeMapping[testType]["url"], {
    category: noteTypeMapping[testType]["category"],
    [noteTypeMapping[testType]["scoreIdKey"]]: scoreId,
    content,
    ...(testType === TEST_TYPES.NATIONAL ? { forwardLooking } : {}),
  })

export const updateScoreNoteApi = ({
  content,
  id,
  testType,
}: {
  content: string
  id: number
  testType: string
}) => PATCH(`${noteTypeMapping[testType]["url"]}/${id}/`, { content })

export const deleteScoreNoteApi = ({
  id,
  testType,
}: {
  id: number
  scoreId: number
  testType: string
}) => DELETE(`${noteTypeMapping[testType]["url"]}/${id}/`)
